export default __webpack_public_path__ + "static/media/haze.37766ef2.svg";